import React from "react";
import { Stack } from "expo-router/stack";

import ChannelHeader from "@/Components/Headers/ChannelHeader";
import { useSession } from "@/context/auth/useSession";
import LoadingScreen from "@/screens/Loading/LoadingScreen";
import MessagingHeader from "@/screens/Messaging/MessagingHeader";

export default function Layout(): React.JSX.Element {
  const { session } = useSession();

  if (session === null) {
    return <LoadingScreen />;
  }

  return (
    <Stack>
      <Stack.Screen
        name="home"
        options={{
          header: () => {
            return <MessagingHeader />;
          },
        }}
      />
      <Stack.Screen
        name="channel"
        options={{
          header: () => {
            return <ChannelHeader session={session} />;
          },
        }}
      />
      <Stack.Screen
        name="thread"
        options={{
          title: "Thread",
        }}
      />
    </Stack>
  );
}
